import { useState, useEffect } from "react";
import { isMobile, isTablet, isDesktop } from "../utils/device";

export function useDevice() {
  const [device, setDevice] = useState({
    mobile: isMobile(),
    tablet: isTablet(),
    desktop: isDesktop(),
  });

  useEffect(() => {
    const handleResize = () => {
      setDevice({
        mobile: isMobile(),
        tablet: isTablet(),
        desktop: isDesktop(),
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return device;
}